import React, { Fragment } from 'react';
import  'jspdf-autotable';
import * as moment from 'moment';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import logoZelo from '../../assets/images.jpg';
import { renderToString } from 'react-dom/server';
import './style2.css';
import _ from "lodash";

const formatCurrency = (value) => {
    return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });
};

export function Pdf_vendedores(dadosParaPDF, comissao, tipoVendedor, nomeUsuario){

    let VendedorFormatado = [];
    if(dadosParaPDF) {

        for(let i in dadosParaPDF) {
            let dataPDF =  dadosParaPDF[i];
            dataPDF.ValorComissaoFormatado = formatCurrency(dataPDF.ValorComissao) ;
            dataPDF.ValorPagoFormatado = formatCurrency(dataPDF.ValorPago);
            dataPDF.PagamentoFormatado = moment(dataPDF.Pagamento).format('DD/MM/YYYY');
            VendedorFormatado.push(dataPDF);
        }
    };

    let cols =[]
    if ( tipoVendedor == "PRIME"){
     cols = [
        { field: 'NomeAssociado', header: 'Nome Associado' },
        { field: 'Id', header: 'Id' },
        { field: 'Inscricao', header: 'Inscrição' },
        { field: 'SubGrupo', header: 'Plano' },
        { field: 'PagamentoFormatado', header: 'Pagamento' },
        { field: 'ValorPagoFormatado', header: 'Valor Pago'},
        { field: 'ValorComissaoFormatado', header: 'Comissão Plano' },
        { field: 'NomeSupervisor', header: 'Nome do Superior' },
    ];
    }else{
        cols = [
            { field: 'NomeAssociado', header: 'Nome Associado' },
            { field: 'Id', header: 'Id' },
            { field: 'Inscricao', header: 'Inscrição' },
            { field: 'NomeCidade', header: 'Cidade' },
            { field: 'TipoVenda', header: 'Tipo Vendas' },
            { field: 'aceite', header: 'Aceite' },
            { field: 'SubGrupo', header: 'Plano' },
            { field: 'Pagamento', header: 'Pagamento' },
            { field: 'ValorPagoFormatado', header: 'Valor Pago' },
            { field: 'PercentualComissao', header: ' % Comissão' },
            { field: 'ValorComissaoFormatado', header: 'Comissão Plano' },

        ];
    }

     const colunas = cols.map((col) => ({
        title: col.header,
        dataKey: col.field,
    }));

    const exportarPDF = () => {
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default({orientation: 'landscape'});
                doc.autoTable( colunas, VendedorFormatado, { theme: 'grid',
                    headStyles: {fillColor: '#00008b'},
                    footStyles: {fillColor: '#808080'},

                    beforePageContent: function() {
                        doc.setFont('normal');
                        doc.setFontSize(14);
                        doc.addImage(logoZelo, 'JPG', 18, 1, 22, 12);
                        doc.text(`Vendedor(a): ${nomeUsuario}`, 100, 8);
                    },

                    foot: [

                        [`Total comissão: ${comissao}`],
                    ]
                })

                doc.save('relatorio-Vendedor.pdf');
            });
        });
    };


    return exportarPDF();

}
//------------------------______________________Supervisor_____________-------------------------------------------

export function Pdf_supervisores(dadosParaPDF, tipoVendedor, nomeUsuario){

    let supervisorFiltro;
    let supervisorComissao ;
    let supervisorFormatado = [];

    if(dadosParaPDF){
        supervisorFiltro = dadosParaPDF[Object.keys(dadosParaPDF)[0]].Vendas;
        supervisorComissao = formatCurrency(dadosParaPDF[Object.keys(dadosParaPDF)[0]].TotalComissaoSupervisor)

        for(let i in supervisorFiltro) {
            let dataPDF =  supervisorFiltro[i];
            dataPDF.ValorComissaoSupervisorFormatado = formatCurrency(dataPDF.ValorComissaoSupervisor) ;
            dataPDF.ValorPagoFormatado = formatCurrency(dataPDF.ValorPago);
            dataPDF.PagamentoFormatado = moment(dataPDF.Pagamento).format('DD/MM/YYYY');
            supervisorFormatado.push(dataPDF);
        }
    }


    let cols =[]
    if ( tipoVendedor == "PRIME"){
     cols = [
        { field: 'nomeVendedor', header: 'Vendedor(a)'},
        { field: 'Id', header: 'Id' },
        { field: 'Inscricao', header: 'Inscrição' },
        { field: 'PagamentoFormatado', header: 'Pagamento' },
        { field: 'ValorPagoFormatado', header: 'Valor Pago'},
        { field: 'ValorComissaoSupervisorFormatado', header: 'Comissão Supervisor(a)' },
        { field: 'NomeAssociado', header: 'Nome Associados' }

    ];
    }else{
        cols = [
            { field: 'nomeVendedor', header: 'Vendedor(a)'},
            { field: 'Id', header: 'Id' },
            { field: 'Inscricao', header: 'Inscrição' },
            { field: 'PagamentoFormatado', header: 'Pagamento' },
            { field: 'ValorPagoFormatado', header: 'Valor Pago' },
            { field: 'ValorComissaoSupervisorFormatado', header: 'Comissão Supervisor(a)' },
            { field: 'NomeAssociado', header: 'Nome Associado' },


        ];
    }

     const colunas = cols.map((col) => ({
        title: col.header,
        dataKey: col.field,
    }));

    const exportarPDF = () => {
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default({orientation: 'landscape'});
                doc.autoTable( colunas, supervisorFormatado, { theme: 'grid',
                columnStyles: {
                    ValorPagoFormatado: {columnWidth: 25},
                    ValorComissaoSupervisorFormatado: {columnWidth: 27},
                    PagamentoFormatado: {columnWidth: 23}
                    },
                    headStyles: {fillColor: '#00008b'},
                    footStyles: {fillColor: '#808080'},
                    beforePageContent: function() {
                        doc.setFont('normal');
                        doc.setFontSize(14);
                        doc.addImage(logoZelo, 'JPG', 18, 1, 22, 12);
                        doc.text(`Supervisor(a): ${nomeUsuario}`, 100, 8);
                    },

                    foot: [

                        [`Total comissão: ${supervisorComissao}`],
                    ]
                })

                doc.save('relatorio-Supervisor.pdf');
            });
        });
    };


    return(
        exportarPDF()
    );
}

//--------------------------------------------teste ----------------------------------

export  function pdfTeste(dadosParaPDF) {

    let supervisorFiltro;
    let supervisorComissao ;
    let supervisorFormatado = [];
// tratando os dados a serem prenchidos no pdf
    if(dadosParaPDF){
        supervisorFiltro = dadosParaPDF[Object.keys(dadosParaPDF)[0]].Vendas;
        supervisorComissao = formatCurrency(dadosParaPDF[Object.keys(dadosParaPDF)[0]].TotalComissaoSupervisor)

        for(let i in supervisorFiltro) {
            let dataPDF =  supervisorFiltro[i];
            dataPDF.ValorComissaoSupervisorFormatado = formatCurrency(dataPDF.ValorComissaoSupervisor) ;
            dataPDF.ValorPagoFormatado = formatCurrency(dataPDF.ValorPago);
            dataPDF.PagamentoFormatado = moment(dataPDF.Pagamento).format('DD/MM/YYYY');
            supervisorFormatado.push(dataPDF);
        }
    }

    let row = [];
    const  Prints = () => {
         row =  supervisorFormatado.map(item =>
        <div  className = "pdf">

     <table>
        <thead style = {{marginTop: '20px'}}>
            <tr style= {{color: 'red'}}>
                <th> Id </th>
                <th> Inscrição </th>
                <th> Nome Associado </th>
                <th> Supervisor </th>
                <th> Pagamento </th>
                <th> Comissão </th>
            </tr>
        </thead>

            <tbody>
                <tr style = {{fontSize: '8px'}}>
                    <th> {item.Id}</th>
                    <th> {item.Inscricao} </th>
                    <th> {item.NomeAssociado}  </th>
                    <th> {item.ValorComissaoSupervisorFormatado} </th>
                    <th> {item.PagamentoFormatado} </th>
                    <th> {item.ValorComissaoSupervisorFormatado} </th>

                </tr>
            </tbody>

        <tfoot>
            <tr>
                <th style = {{fontSize: '10px'}}> Total Comissao <span>${item.ValorPagoFormatado}</span></th>
            </tr>
        </tfoot>
    </table>
        </div>
        )
        return row;
    };


    const exportarPDF = () => {
        const string = renderToString(<Prints/>);
        const pdf = new jsPDF('i', 'pt');
        pdf.html(string, {
            callback: function(pdf) {
                pdf.save('pdf')
            },
            x: 14,
            Y: 20
        });


    }
        return ( exportarPDF() );
}


